export default "__VITE_ASSET__De6vq3hy__"